// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ik7w4","detailsBorder":"styles_detailsBorder__k6hVg"};